import { CHANGE_FAVOURITE_VALUE, COURSES_IS_LOADING, COURSES_LOAD_ERROR, COURSES_LOAD_SUCCESS, END_SETTING_FAVOURITE, START_SETTING_FAVOURITE } from "../actions/action_types";

export default function coursesReducer(state = { coursesData: [], isLoading: false, coursesError: null, favouriteIsLoading : false }, action) {
    switch (action.type) {
        case COURSES_IS_LOADING:
            return {...state, isLoading: true }
        case COURSES_LOAD_SUCCESS:
            return {...state, coursesData: action.payload, isLoading: false }
        case COURSES_LOAD_ERROR:
            return {...state, coursesError: action.payload, isLoading: false }
        case CHANGE_FAVOURITE_VALUE:
            let manipulatedCoursesData = state.coursesData.map(filter => filter.map(course => course.id === action.payload ? {...course, favourite: course.favourite === 'Yes' ? 'No':'Yes'} : course))
            return {...state, coursesData: manipulatedCoursesData, favouriteIsLoading : false}
        case START_SETTING_FAVOURITE:
            return {...state, favouriteIsLoading:true}
        case END_SETTING_FAVOURITE:
            return {...state, favouriteIsLoading:false}
        default:
            return state
    }
}